export default "__VITE_ASSET__64742b7f__"